enum HomeTabSubDeepLinks {
  Journal = "journal",
  Task = "task",
}

export { HomeTabSubDeepLinks };
